export default "__VITE_ASSET__f9f2079c__"